//App.js
import {
  BrowserRouter,
  Navigate,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import { useSelector } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';

import "./App.css";
import NotFound from "./pages/NotFound";
import NotRights from "./pages/NotRights";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

import Signup from "./pages/signup";
import RequestPasswordReset from "./components/Signup/Login/requestPasswordReset";
import ResetPassword from "./components/Signup/Login/ResetPassword";
import OtpVerification from "./components/Signup/register/otpVerification";

import Menu from "./pages/Menu";
import Start from "./pages/Start";

import Profil from "./private/profil";
import Home1 from "./private/home";
import Service from "./private/service";

import UProfile from "./private/User/uProfil";
import UserProfile from "./private/User/components/userProfile";
import Profilbild from "./private/User/components/profilbild";

import Dashboard from "./private/dashboard";

import SsoLogin from "./components/Signup/SSO/SsoLogin";
import AdminSendSso from "./private/Admin/AdminSendSso";
import CompleteProfile from "./components/Signup/SSO/CompleteProfile";

import KartArchive from "./private/Admin/kartArchive";
import AddProduct from "./private/Admin/AddProductForm";
import DeleteProduct from "./private/Admin/DeleteProduct";
import UserManagement from "./private/Admin/UserManagement";
import Support from "./private/Admin/Support";
import CategoryPage from "./pages/components/CategoryPage";
import Karte1 from "./pages/components/Karte1";
import EventUploadForm from "./private/Admin/EvemtUploadForm";
import EventDeleteForm from "./private/Admin/EventDeleteForm";
import CategoryOrder from "./private/Admin/CategoryOrder";



const PrivateRoutes = () => {
  const { isAuth } = useSelector((state) => state.auth);

  return <>{isAuth ? <Outlet /> : <Navigate to="/" />}</>;
};

const RestrictedRoutes = () => {
  const { isAuth } = useSelector((state) => state.auth);

  return <>{!isAuth ? <Outlet /> : <Navigate to="/dashboard" />}</>;
};

const App = () => {
  const { userRole } = useSelector((state) => state.role);
  const isAdmin = userRole === "admin";
  const isUser = userRole === "user";
  const isWorker = userRole === "worker";

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PrivateRoutes />}>
          {isAdmin ? (
            <>
              <Route path="/user/profile/settings" element={<UProfile />} />
              <Route path="/user/profile/data" element={<UserProfile />} />
              <Route path="/user/profile/picture" element={<Profilbild />} />
              <Route path="/admin/ssoinv" element={<AdminSendSso />} />
              <Route path="/admin/kart-archive" element={<KartArchive />} />
              <Route path="/admin/add-product" element={<AddProduct />} />
              <Route path="/admin/delete-product" element={<DeleteProduct />} />
              <Route
                path="/admin/user-management"
                element={<UserManagement />}
              />
              <Route path="/admin/event-upload" element={<EventUploadForm />} />
              <Route path="/admin/event-delete" element={<EventDeleteForm />} />
              <Route path="/support" element={<Support />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin/category-order" element={<CategoryOrder />} />
            </>
          ) : (
            <Route path="/*" element={<NotRights />} />
          )}
          {isUser ? (
            <>
              <Route path="/user/profile/settings" element={<UProfile />} />
              <Route path="/user/profile/data" element={<UserProfile />} />
              <Route path="/user/profile/picture" element={<Profilbild />} />
              <Route path="/user/kart-archive" element={<KartArchive />} />
              <Route path="/support" element={<Support />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </>
          ) : (
            <Route path="/*" element={<NotRights />} />
          )}
          {isWorker ? (
            <>
              <Route path="/user/profile/settings" element={<UProfile />} />
              <Route path="/user/profile/data" element={<UserProfile />} />
              <Route path="/user/profile/picture" element={<Profilbild />} />
              <Route path="/worker/kart-archive" element={<KartArchive />} />
              <Route path="/worker/kart-archive" element={<KartArchive />} />
              <Route path="/worker/add-product" element={<AddProduct />} />
              <Route path="/support" element={<Support />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </>
          ) : (
            <Route path="/*" element={<NotRights />} />
          )}

          <Route path="/home" element={<Home1 />} />
          <Route path="/profil" element={<Profil />} />
          <Route path="/service" element={<Service />} />
        </Route>

        <Route element={<RestrictedRoutes />}>
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/request-password-reset"
            element={<RequestPasswordReset />}
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/otp-verification" element={<OtpVerification />} />
          <Route path="/sso-login" element={<SsoLogin />} />
          <Route path="/complete-profile" element={<CompleteProfile />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/menulist" element={<Karte1 />} />
          <Route path="/menu/:category" element={<CategoryPage />} />
          <Route path="/impressum" element={<Impressum />} />
<Route path="/datenschutz" element={<Datenschutz />} />

          <Route path="/" element={<Start />} />
        </Route>

        <Route path="*" element={<NotFound />} />
        <Route path="/*" element={<NotRights />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
